module.exports = __webpack_public_path__ + "img/background01.2fd2deee.jpg";